<template>
  <div
    class="dot-loader-parent"
    :style="'height:' + size + '; width:' + size + ';'"
  >
    <div
      class='dot-loader'
    >
      <div
        v-for="(dot, i) in dots"
        :key="i"
        :style="'animation-play-state: ' + dot.playState + ';'"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',

  props: {
    size: {
      type: String,
      required: false,
      default: '40px',
    },

    once: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => ({
    dots: [
      {
        playState: 'paused',
      },
      {
        playState: 'paused',
      },
      {
        playState: 'paused',
      },
    ]
  }),

  created() {

  },

  mounted() {
    if (this.once) {
      const delay = 1000;

      setTimeout(() => {
        this.dots.forEach(dot => {
          dot.playState = '';
        });
      }, delay)

      setTimeout(() => {
        this.dots.forEach(dot => {
          dot.playState = 'paused';
        });
      }, delay + 3200)
    }
    else {
      this.dots.forEach(dot => {
        dot.playState = '';
      });
    }
  }
}
</script>

<style scoped>
  .dot-loader {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .dot-loader > * {
    position: absolute;
    width: 30%;
    height: 30%;
    border-radius: 100%;
    animation: dot-loader 2.4s cubic-bezier(0.5, 0, 0, 1) infinite;
  }
  .dot-loader > *:nth-child(1) {
    animation-delay: -1.6s;
    background: #4573A6;
  }
  .dot-loader > *:nth-child(2) {
    animation-delay: -0.8s;
    background: #E9D935;
  }
  .dot-loader > *:nth-child(3) {
    animation-delay: 0s;
    background: #E94235;
  }

  @keyframes dot-loader {
    0%, 3.3% {
      top: 0%; left: 35%;
    }
    30%, 36.6% {
      top: 70%; left: 70%;
    }
    63.3%, 69.9% {
      top: 70%; left: 0%;
    }
    96.7%, 100% {
      top: 0%; left: 35%;
    }
  }
</style>
